// extracted by mini-css-extract-plugin
module.exports = {"card":"paragraphsCard_card__17p7G","titleSection":"paragraphsCard_titleSection__2QaIC","chartSection":"paragraphsCard_chartSection__3uHOm"};